export const styles = {
  dialogContent: {
    height: '75vh',
    display: 'flex',
    flexDirection: 'column',
  },
};
